import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { RESET_PASSWORD } from "redux-store/users/actions";
import { ResetPasswordPage } from "view/auth/reset-password";
import { getAppName } from "view/auth/utils";

function mapStateToProps() {
  return {
    title: getAppName(),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onResetPassword: (token, password, passwordRepeat) => {
      return createPromiseApiAction(dispatch, RESET_PASSWORD, [
        token,
        password,
        passwordRepeat,
      ]);
    },
  };
}

const ConnectedResetPasswordPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordPage);

export { ConnectedResetPasswordPage };
